import { IAllPrivateRoutes } from "components/routes/app_routes";
import { user } from "config/roles";
import { HomeRequests, NationalTransport, SamaPapser, Tour } from "../screens";

export const RequestRoutes: IAllPrivateRoutes[] =
  process.env.REACT_APP_SAMA_PAPSER_DISABLED_CHECK === "false"
    ? [
        { label: "Request", pathName: "/tracking/request", routeElement: HomeRequests, roles: user.roles },
        { label: "Request", pathName: "/tracking/request/samapapser", routeElement: SamaPapser, roles: user.roles },
        {
          label: "Request",
          pathName: "/national-transport",
          routeElement: NationalTransport,
          roles: user.roles,
        },
        {
          label: "Request",
          pathName: "/tracking/request/tour",
          routeElement: Tour,
          roles: user.roles,
        },
      ]
    : [];
